// extracted by mini-css-extract-plugin
module.exports = {"gridArea":"CustomGridWrapper_gridArea__JNiHi"};